<template>
  <v-app class="left-bar-layout">
    <div class="max-height" style="display: flex;">
      <v-content>
        <v-container fluid pa-0 style="height: 100%;">
          <v-layout justify-center fill-height>
            <v-flex md3 lg2 hidden-sm-and-down class="menu-background menu-min-width">
              <v-img
                :src="logoPath()"
                height="40px"
                contain
                style="margin-top: 12px;">
              </v-img>
              <v-select
                @change="setLanguage"
                v-model="selected_language"
                class="language-selector"
                :items="languages"
                item-text="display"
                item-value="code"
                label="Language"
                prepend-icon="language"
                outlined
                dark
              ></v-select>
              <v-btn
                block
                class="download-btn"
                @click="triggerDownload"
              >
                {{i18n('Baixar recibo')}}
              </v-btn>
            </v-flex>
            <v-flex md9 lg10 class="flex-col">
              <div class="top-bar"></div>
              <v-layout row wrap>
                <v-flex xs12 class="flex-col">
                  <slot></slot>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
    </div>
  </v-app>
</template>
<script>
import AppMenu from "../Menu"
import Navbar from '../components/Navbar'

export default {
  name: 'BaseLeftBarLayout',
  components: {
    'app-menu': AppMenu,
    Navbar,
  },
  props: {},
  data(vm) {
    return {
      selected_language: vm.$root.lang,
      languages: [
        { code: 'pt', currency: 'BRL', display: 'Português' },
        { code: 'en', currency: 'USD', display: 'English' },
        { code: 'es', currency: 'MXN', display: 'Español' }
      ]
    }
  },
  methods: {
    i18n(str) {
      return this.$root.i18n[str] && this.$root.i18n[str][this.selected_language] || str
    },
    setLanguage() {
      this.$root.$emit('syncLang', this.selected_language)
      this.$forceUpdate()
    },
    triggerDownload() {
      this.$root.$emit('downloadReceipt')
    },
    logoPath() {
      if (this.$root.getEnvironment() === 'prod') return '/static/logo.svg'
      return '/static/logo-dev.svg'
    }
  }
}
</script>
<style>
  @import url("https://use.typekit.net/gbx5lto.css");

  .left-bar-layout {
    font-family: 'Paralucent';
  }

  .menu-background {
    background: #06233B !important;
    padding-top: 20px;
  }

  .left-bar-layout h1.max {
    font-family: 'Paralucent';
    font-weight: 500;
    font-size: 24px !important;
    line-height: 22px;
    color: #0C2E4A;
  }

  .menu-min-width {
    width: 260px!important;
  }

  .download-btn {
    margin-left: auto;
    margin-right: auto;
    width: 80%;
  }

  .language-selector {
    margin-top: 84px;
    padding: 0 20px 0 20px;
  }

  .top-bar {
    background-color: white;
    display: flex;
    padding-right: 70px;
    padding-top: 24px;
    padding-bottom: 20px;
    margin-bottom: 18px;
  }

  body,
  div.max-height { height: 100%!important; position: relative!important; }

</style>



// WEBPACK FOOTER //
// src/layouts/BaseLeftBarLayout.vue